import { ReactNode } from 'react';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

interface LinkType {
  href: string;
  children?: ReactNode;
}

/**
 * Transforms markdown syntax to another element than the default defined in react-markdown
 * Currently only transforms anchor element ( to next.js Link element )
 * disableParsingRawHTML - means no html tag will be treated as a tag, but as a text.
 * @constructor
 * @param {string} onMore handler for read more link
 * @returns { link: ReactNode }
 * for the supported properties see the [react-markdown docs] {@link https://github.com/rexxars/react-markdown#node-types }
 */
const renderers = (onMore: () => void) => ({
  disableParsingRawHTML: true,
  overrides: {
    a: function MarkdownRenderer({ children, href }: LinkType) {
      const market = useMarket();

      if (href === 'more') {
        return (
          <a className="bsdesc-more" onClick={onMore}>
            {children && children}
          </a>
        );
      }

      const [hrefPart] = href.split('/').filter(Boolean);
      const validatedHref = hrefPart === market.alias ? href : `/${market.prefix}${href}`;

      return (
        <a href={validatedHref} className="bsdesc-link">
          {children && children}
        </a>
      );
    },
  },
});

export default renderers;
